import AddonInterface from 'interfaces/Addon.interface';
import IntakeConfig from '../interfaces/IntakeConfig.interface';

const getAddonList = (config: IntakeConfig, formValues: any) => {
  const result: Array<AddonInterface> = [];
  const planConfig = config.plan?.countries[formValues.address.country].periods.find(p => p.id === formValues.plan);
  planConfig?.addons.forEach(
    (addon) => {
      const value = formValues.addons?.[addon.id];
      if (!value) return;
      switch (addon.type) {
        case 'multiselect':
          value.forEach((v: string) => {
            const option = addon.options.find(o => o.id === v);
            if (!option) return;
            result.push({
              addon,
              option,
              id: option.itemPriceId || option.id,
              label: option.label,
              price: option.price,
              unit: option.unit,
            });
          });
          break;
        default:
          break;
      }
    },
  );
  return result;
};

export default getAddonList;
